import { Box, Text } from '@bechtel/gds';
import styled, { css } from 'styled-components';

interface LegendItemProps {
  selected: boolean;
}
export const LegendItemStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})<LegendItemProps>`
  ${({ theme, selected }) => css`
    border: ${selected ? `1px solid ${theme.colors.blue[500]}` : ''};
    border-radius: ${theme.radii[300]};
    padding: ${theme.spacings[200]} ${theme.spacings[400]};
    height: 24px;
    background-color: ${selected ? theme.colors.blue[100] : theme.colors.white};
    cursor: pointer;
    &:hover {
      box-shadow: ${theme.componentStyles.boxShadow};
    }
  `}
`;

export const LegendLabelStyled = styled(Text).attrs({
  size: 300,
})`
  ${({ theme }) => css`
    color: ${theme.colors.grey[800]};
  `}
`;

export const LegendValueStyled = styled(Text).attrs({
  size: 400,
  weight: 600,
})`
  text-align: start;
  ${({ theme }) => css`
    margin-right: ${theme.spacings[450]};
  `}
`;
